export default {
  default: 0.5,
  soft: 0.8,
}
